module.exports = __webpack_public_path__ + "static/assets/19018035a8a4de47a3d2b4b44f89548a.svg";